module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Bold.04875d26.woff2";